export const APP_NAME = process?.env?.REACT_APP_NAME || 'Bavaria'; // used for alt-texts.
export const LIST_CACHE_EXPIRY_TIME = 5 * 60 * 1000;
